<template>
  <v-container class="my-5">
    <!--   Diálogo para Mostrar un mensaje al Eliminar Registro del Directorio     -->
    <v-dialog v-model="errorDialog" max-width="450" class="justify-center">
      <v-card class="justify-center">
        <v-card-title class="gray display-1 text--primary justify-center" primary-title>
          {{ $t('aviso') }}
        </v-card-title>
        <v-card-text class="justify-center">
          {{ errorMessages }}
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn small color="primary" @click="errorDialog = false">
            {{ $t('aceptar') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--     Diálogo Modal Persistente para Recortar Logotipo del Fraccionamiento      -->
    <v-dialog v-model="dialogImageLogo" persistent scrollable max-width="800px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>
            {{ $t('recortar_imagen') }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <clipper-fixed mode="normal" class="basic lg" ref="clipperImageLogo" :src="imageFrontURL">
          </clipper-fixed>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn color="primary" @click="getCutingLogo()">{{ $t('recortar') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--   Diálogo para Mostrar un mensaje al Eliminar Registro del Directorio     -->
    <v-dialog v-model="deleteDialog" max-width="500">
      <v-card>
        <v-card-title class="headline">
          {{ $t('msg_delete_schedule') }}
        </v-card-title>

        <v-card-text>
          {{ $t('msg_accion_deshacer') }}
        </v-card-text>

        <v-card-actions>
          <v-btn color="primary" @click="deleteDialog = false">
            No
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="deleteSportSchedule()">
            {{ $t('Si') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--   Diálogo para Agregar/Modificar Horarios    -->
    <v-dialog v-model="dialog" persistent scrollable max-width="450">
      <v-form @submit.prevent="update
        ? updateSportSchedue(idUpdate)
        : addSportSchedule()">
        <v-card class="elevation-5">
          <v-toolbar dark color="primary">
            <v-toolbar-title>
              {{ $t('schedule') }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="align-self-end" color="red" icon
              @click="clear(), dialog = false"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-card-text>
            <v-autocomplete v-model="weekday" prepend-icon="mdi-soccer" name="weekday" item-text="name" item-value="id"
              :label="'*' + $t('weekday')" :placeholder="$t('choose_day')" :error-messages="errores.day"
              :items="weekdays" no-data-text="Ningún Resultado" outlined clearable autocomplete="off">
            </v-autocomplete>
            <v-autocomplete v-model="initialTime" prepend-icon="mdi-clock" name="initialTime" item-text="schedule"
              item-value="schedule" :label="'*' + $t('check_in_time')" :error-messages="errores.initialTime"
              :items="schedules" no-data-text="Ningún Resultado" outlined clearable autocomplete="off">
            </v-autocomplete>
            <v-autocomplete v-model="finalTime" prepend-icon="mdi-clock" name="finalTime" item-text="schedule"
              item-value="schedule" :label="'*' + $t('check_out_time')" :error-messages="errores.finalTime"
              :items="schedules" no-data-text="Ningún Resultado" outlined clearable autocomplete="off">
            </v-autocomplete>
            <v-text-field v-model="instructor_name" name="instructor_name" counter outlined maxlength="100"
              prepend-icon="mdi-account" :label="$t('instructor_name')"
              :error-messages="errores.instructor_name"></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="clear(), dialog = false">{{ $t('cerrar') }}</v-btn>
            <v-spacer />
            <v-btn v-if="update" :loading="loading" color="primary" type="submit">{{ $t('modificar') }}</v-btn>
            <v-btn v-else :loading="loading" color="primary" type="submit">{{ $t('agregar') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <h2 class="subheading grey--text">{{ $t('courts') }}</h2>
    <v-layout align-center justify-center fill-height>
      <v-card class="elevation-5">
        <v-toolbar dark color="primary">
          <v-toolbar-title>
            {{ $t('courts') }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="12">
              <v-autocomplete v-model="idSport" prepend-icon="mdi-soccer" name="idSport" item-text="name"
                item-value="id" :label="'*' + $t('courts')" :placeholder="$t('choose_court')"
                :error-messages="errores.idSport" :items="courts" no-data-text="Ningún Resultado" outlined clearable
                @change="loadSportSchedule" autocomplete="off">
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-layout>
    <v-layout class="my-4" align-center justify-center fill-height>
      <v-row>
        <v-col>
          <v-sheet height="100%">
            <v-calendar ref="calendar" :now="today" :value="today" :events="events" :event-color="getEventColor"
              :weekdays="[1, 2, 3, 4, 5, 6, 0]" color="primary" type="week" @click:event="showEvent"
              :locale="$t('region')" :first-interval="14" :interval-minutes="30" :interval-count="30"
              :short-intervals="false" :short-weekdays="false">
            </v-calendar>
            <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" offset-x>
              <v-card v-if="selectedEvent.status !== -1" color="grey lighten-4" min-width="350px" flat>
                <v-toolbar :color="selectedEvent.color" dark>
                  <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <!-- <v-card-title>{{$t('booking_in_name_of')}} {{selectedEvent.host}}</v-card-title> -->
                  <v-card-title>{{ selectedEvent.host }}</v-card-title>
                  <v-card-subtitle>{{ $t('schedule') }}: {{ selectedEvent.initialSchedule }} -
                    {{ selectedEvent.finalschedule }}</v-card-subtitle>
                  <v-card-title v-if="selectedEvent.invited_people">{{ $t('invitados') }}</v-card-title>
                  <!-- <v-card-subtitle v-for="(item, index) in selectedEvent.invited_people" v-bind:key="index">{{item}}</v-card-subtitle> -->
                  <v-list v-if="selectedEvent.invited_people === []">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>Sin Invitados</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                  <v-list v-else>
                    <template v-for="(item, index) in selectedEvent.invited_people">
                      <v-list-item :key="index">
                        <v-list-item-content>
                          <v-list-item-title v-html="item"></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list>
                  <!-- <v-card-subtitle>{{selectedEvent.invited_people}}</v-card-subtitle> -->
                  <!-- <v-card-subtitle>{{selectedEvent.id}}</v-card-subtitle> -->
                  <!-- <v-card-subtitle v-if="selectedEvent.nameInstructors !== null" >{{ $t('instructor_name') }}: <strong>{{selectedEvent.nameInstructors}}</strong></v-card-subtitle> -->
                </v-card-text>
                <v-card-actions v-if="selectedEvent.status === 1">
                  <v-btn v-if="selectedEvent.status === 1" :loading="loadingConfirmBooking" color="red"
                    @click="changeStatusBooking(selectedEvent.id, 4)">
                    {{ $t('cancel_reservation') }}
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn v-if="selectedEvent.status === 1" :loading="loadingConfirmBooking" color="green"
                    @click="changeStatusBooking(selectedEvent.id, 2)">
                    {{ $t('confirm_booking') }}
                  </v-btn>
                </v-card-actions>
                <v-card-actions v-if="selectedEvent.status === 3">
                  <v-btn v-if="selectedEvent.status === 3" :loading="loadingConfirmBooking" color="red"
                    @click="acceptOrRejectCancellation(selectedEvent.id, 'reject')">
                    {{ $t('reject') }}
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn v-if="selectedEvent.status === 3" :loading="loadingConfirmBooking" color="green"
                    @click="acceptOrRejectCancellation(selectedEvent.id, 'approve')">
                    {{ $t('approve') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
              <v-card v-else color="grey lighten-4" min-width="350px" flat>
                <v-toolbar :color="selectedEvent.color" dark>
                  <v-toolbar-title>{{ selectedEvent.name }} {{ $t('schedule') }}: {{ selectedEvent.initialSchedule }} -
                    {{ selectedEvent.finalschedule }}</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <v-autocomplete v-model="idOwner" prepend-icon="mdi-account-star" name="idOwner" item-text="fullname"
                    item-value="idUser.id" :label="'*' + $t('residente_principal')" :placeholder="$t('choose_owner')"
                    :error-messages="errores.idOwner" :items="owners" no-data-text="Ningún Resultado" outlined clearable
                    autocomplete="off">
                  </v-autocomplete>
                  <!-- <v-card-title>{{$t('booking_created_by')}} {{selectedEvent.host}}</v-card-title> -->
                  <!-- <v-card-subtitle>{{$t('invitados')}}: {{selectedEvent.initialSchedule}} - {{selectedEvent.finalschedule}}</v-card-subtitle> -->
                  <v-card-subtitle>{{ $t('invitados') }} máx. 4</v-card-subtitle>
                  <v-text-field v-model="guest01" name="guest01" counter outlined maxlength="100"
                    prepend-icon="mdi-account" :label="'*' + $t('full_name')"
                    :error-messages="errores.name"></v-text-field>
                  <v-text-field v-model="guest02" name="guest01" counter outlined maxlength="100"
                    prepend-icon="mdi-account" :label="'*' + $t('full_name')"
                    :error-messages="errores.name"></v-text-field>
                  <v-text-field v-model="guest03" name="guest01" counter outlined maxlength="100"
                    prepend-icon="mdi-account" :label="'*' + $t('full_name')"
                    :error-messages="errores.name"></v-text-field>
                  <v-text-field v-model="guest04" name="guest01" counter outlined maxlength="100"
                    prepend-icon="mdi-account" :label="'*' + $t('full_name')"
                    :error-messages="errores.name"></v-text-field>
                  <!-- <v-card-subtitle>{{$t('schedule')}}: {{selectedEvent.initialTime}} - {{selectedEvent.finalTime}}</v-card-subtitle> -->
                  <!-- <v-card-subtitle>{{$t('invitados')}}<br>{{selectedEvent.invited_people}}</v-card-subtitle> -->
                  <!-- <v-card-subtitle>{{selectedEvent.invited_people}}</v-card-subtitle> -->
                  <!-- <v-card-subtitle>{{selectedEvent.id}}</v-card-subtitle> -->
                  <!-- <v-card-subtitle v-if="selectedEvent.nameInstructors !== null" >{{ $t('instructor_name') }}: <strong>{{selectedEvent.nameInstructors}}</strong></v-card-subtitle> -->
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn :loading="loadingConfirmBooking" color="green" @click="createBooking(selectedEvent.start)">
                    {{ $t('create_booking') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-sheet>
        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import VuejsClipper from 'vuejs-clipper'
import { mapGetters, mapState } from 'vuex'
import Vue from 'vue'

Vue.use(VuejsClipper, {
  components: {
    clipperBasic: 'clipper-basic',
    clipperFixed: 'clipper-fixed',
    clipperUpload: 'clipper-upload'
  }
})

export default {
  name: 'sports_schedules',
  created () {
    this.getCourts()
    this.getAllOWners()
  },
  computed: {
    ...mapGetters(['getProfile']),
    ...mapState(['language'])
  },
  data: () => ({
    dialog: false,
    idHouse: '',
    idSport: '',
    initialTime: '',
    weekday: '',
    finalTime: '',
    initialTimeAux: '',
    finalTimeAux: '',
    header: [],
    loadingDataDirectory: false,
    loading: false,
    loadingConfirmBooking: false,
    courts: [],
    schedule_by_sport: [],
    weekdays: [
      {
        id: 0,
        name: 'Lunes'
      },
      {
        id: 1,
        name: 'Martes'
      },
      {
        id: 2,
        name: 'Miércoles'
      },
      {
        id: 3,
        name: 'Jueves'
      },
      {
        id: 4,
        name: 'Viernes'
      },
      {
        id: 5,
        name: 'Sábado'
      },
      {
        id: 6,
        name: 'Domingo'
      }
    ],
    search: '',
    update: false,
    errores: [],
    errorsPhone: [],
    idUpdate: 0,
    idDirectoryDelete: 0,
    deleteDialog: false,
    dialogImageLogo: false,
    file: null,
    rules: [
      value => !value || value.type === 'application/vnd.ms-excel' || 'Archivo con formato incorrecto.'
    ],
    headers: [],
    resultLogoURL: '',
    imageFrontURL: '',
    today: new Date().toISOString().slice(0, 10),
    // today: '2025-03-31',
    selectedOpen: false,
    selectedEvent: [],
    selectedElement: null,
    events: [],
    instructor_name: '',
    schedules: [
      {
        id: 5,
        schedule: '05:00'
      },
      {
        id: 6,
        schedule: '06:00'
      },
      {
        id: 7,
        schedule: '07:00'
      },
      {
        id: 8,
        schedule: '08:00'
      },
      {
        id: 9,
        schedule: '09:00'
      },
      {
        id: 10,
        schedule: '10:00'
      },
      {
        id: 11,
        schedule: '11:00'
      },
      {
        id: 12,
        schedule: '12:00'
      },
      {
        id: 13,
        schedule: '13:00'
      },
      {
        id: 14,
        schedule: '14:00'
      },
      {
        id: 15,
        schedule: '15:00'
      },
      {
        id: 16,
        schedule: '16:00'
      },
      {
        id: 17,
        schedule: '17:00'
      },
      {
        id: 18,
        schedule: '18:00'
      },
      {
        id: 19,
        schedule: '19:00'
      },
      {
        id: 20,
        schedule: '20:00'
      },
      {
        id: 21,
        schedule: '21:00'
      }
    ],
    errorDialog: false,
    errorMessages: '',
    idCourt: '',
    idOwner: '',
    guest01: '',
    guest02: '',
    guest03: '',
    guest04: '',
    owners: []
  }),
  mounted () {
    this.$refs.calendar.scrollToTime('08:00')
  },
  beforeUpdate () {
    this.headers = [
      {
        text: this.$t('acciones'),
        align: 'center',
        sortable: false,
        value: 'action'
      },
      {
        text: this.$t('nombre'),
        align: 'center',
        sortable: true,
        value: 'name'
      },
      {
        text: this.$t('telefono'),
        align: 'center',
        sortable: true,
        value: 'number'
      }
    ]
  },
  methods: {
    getAllOWners () {
      const config = {
        method: 'get',
        url: 'https://clubtest.intrare.app/residents/all',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.owners = response.data.residents
          // this.loadingDataAllResidents = false
        })
        .catch(error => {
          // this.loadingDataAllResidents = false
          console.log(error)
        })
    },
    editSchedule (id) {
      console.log(id)
    },
    loadSportSchedule () {
      console.log('Fill Calendar')
      if (this.idSport === undefined) {
        this.events = []
      } else {
        this.getCourtData(this.idSport)
      }
    },
    getWeekDaysFromDate (aDate) {
      let dates = []
      let day = this.getWeekDayFromDate(aDate)
      // console.log('Dias')
      // console.log(day)
      // console.log('Dia sin sumar')
      // console.log(aDate)
      let aux = aDate.setDate(aDate.getDate() - day)
      // console.log('Dia sumado')
      // console.log(new Date(aux))
      for (let i = 0; i < 8; i++) {
        let start = new Date(aux)
        dates.push(new Date(start.setDate(start.getDate() + i)))
      }
      // console.log(dates)
      return dates
    },
    createGrid (court) {
      console.log('SEGUNDO')
      let fechaActual = new Date()
      // console.log('FECHA ACTUAL', fechaActual.toISOString().slice(0, 10))
      let weekdaysInitial = this.getWeekDaysFromDate(new Date(fechaActual.toISOString().slice(0, 10) + ' ' + court.opening_time))
      console.log('weekdaysInitial', weekdaysInitial)
      let weekdaysFinal = this.getWeekDaysFromDate(new Date(fechaActual.toISOString().slice(0, 10) + ' ' + court.closing_time))
      for (let i = 0; i < weekdaysInitial.length; i++) {
        let inicio = weekdaysInitial[i]
        let fin = weekdaysFinal[i]
        // console.log(fin)
        // console.log(inicio)
        let minutos = ((fin - inicio) / 1000) / 60
        // console.log('Minutos = ', minutos)
        let numReservacionesXDia = minutos / court.time_interval
        // console.log('numReservacionesXDia = ', numReservacionesXDia)
        console.log('court.opening_days.includes(i.toString()) = ', (court.opening_days.includes(i.toString())))
        for (let j = 0; j < numReservacionesXDia && ((court.opening_days.includes((i - 1).toString())) === true); j++) {
          let day = this.getWeekDayFromDate(inicio)
          const firstTimestamp = court.time_interval * 60000 * (j)
          let inicioAux = new Date(inicio.getTime() + firstTimestamp - (360 * 60000))
          const secondTimestamp = court.time_interval * 60000 * (1 + j)
          let final = new Date(inicio.getTime() + secondTimestamp - (360 * 60000))
          // console.log(inicio)
          // console.log(final)
          // console.log(final.toISOString().slice(0, 10) + ' ' + final.toISOString().slice(11, 16))
          let color = '#7DA1EA'
          this.events.push(
            {
              id: 123,
              name: 'Reservar',
              color: color,
              start: inicioAux.toISOString().slice(0, 10) + ' ' + inicioAux.toISOString().slice(11, 16),
              end: final.toISOString().slice(0, 10) + ' ' + final.toISOString().slice(11, 16),
              initialTime: inicioAux.toISOString().slice(0, 10) + ' ' + inicioAux.toISOString().slice(11, 16),
              finalTime: final.toISOString().slice(0, 10) + ' ' + final.toISOString().slice(11, 16),
              weekday: this.convertNumberToWeekday(day),
              initialSchedule: inicioAux.toISOString().slice(11, 16),
              finalschedule: final.toISOString().slice(11, 16),
              status: -1,
              day: day
            }
          )
          // console.log('Se agrego un aentrada a Eventos')
        }
      }
    },
    showEvent ({ nativeEvent, event }) {
      const open = () => {
        console.log('Datos del Evento = ', event)
        this.idOwner = ''
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        this.errores = []
        this.guest01 = this.guest02 = this.guest03 = this.guest04 = ''
        // eslint-disable-next-line no-return-assign
        requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        requestAnimationFrame(() => requestAnimationFrame(() => open()))
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },
    getEventColor (event) {
      return event.color
    },
    addDaysToToday (numDays) {
      let fecha = new Date(this.today)
      fecha.setDate(fecha.getDate() + numDays)
      // console.log('Fecha')
      // console.log(fecha.toISOString().slice(0, 10))
      return fecha.toISOString().slice(0, 10)
    },
    rnd (a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a
    },
    getBookingToCalendar (items) {
      // this.events = []
      let band
      for (let i = 0; i < items.length; i++) {
        band = false
        for (let j = 0; j < this.events.length && !band; j++) {
          // console.log('start j =', this.events[j].start)
          // console.log('START i =', items[i].date + ' ' + items[i].hour.slice(0, 5))
          if ((items[i].date + ' ' + items[i].hour.slice(0, 5)) === this.events[j].start) {
            // console.log('CONCIDENCIA')
            band = true
            this.events.splice(j, 1)
          }
        }
      }
      for (let i = 0; i < items.length; i++) {
        console.log(items[i])
        let day = this.getWeekDayFromDate(items[i].date)
        let inicio = new Date(items[i].date + ' ' + items[i].hour)
        let inicioAux = new Date(inicio.getTime() - (360 * 60000))
        const secondTimestamp = items[i].court.time_interval * 60000
        let fin = new Date(inicio.getTime() + secondTimestamp - (360 * 60000))
        // console.log(inicio)
        // console.log(fin)
        // console.log(fin.toISOString().slice(0, 10) + ' ' + fin.toISOString().slice(11, 16))
        let color = '#757575'
        let name = ''
        // (1, "Pending"),
        // (2, "Confirmed"),
        // (3, "Cancellation Requested"),
        // (4, "Cancelled"),
        // (5, "Rejected"),
        switch (items[i].status) {
          case 1:
            color = 'grey darken-1'
            name = this.$t('pendiente')
            break
          case 2:
            color = 'green'
            name = this.$t('confirmed')
            break
          case 3:
            color = 'orange'
            name = this.$t('cancellation_requested')
            break
          case 4:
            color = 'red'
            name = this.$t('Cacelada')
            break
          case 5:
            color = 'blue'
            name = this.$t('rejected')
            break
          default:
            color = '#757575'
        }
        this.events.push(
          {
            id: items[i].id,
            // name: 'Estado ' + items[i].status + ' ' + items[i].user.first_name + ' ' + items[i].user.last_name + ' ' + items[i].court.name,
            name: name,
            color: color,
            start: inicioAux.toISOString().slice(0, 10) + ' ' + inicioAux.toISOString().slice(11, 16),
            end: fin.toISOString().slice(0, 10) + ' ' + fin.toISOString().slice(11, 16),
            initialTime: inicioAux.toISOString().slice(0, 10) + ' ' + inicioAux.toISOString().slice(11, 16),
            finalTime: fin.toISOString().slice(0, 10) + ' ' + fin.toISOString().slice(11, 16),
            weekday: this.convertNumberToWeekday(day),
            day: day,
            status: items[i].status,
            initialSchedule: inicioAux.toISOString().slice(11, 16),
            finalschedule: fin.toISOString().slice(11, 16),
            invited_people: items[i].invited_people,
            host: items[i].user.first_name + ' ' + items[i].user.last_name
          }
        )
        console.log('cadena = ', items[i].invited_people)
      }
    },
    getWeekDayFromDate (aDate) {
      const valentines = new Date(aDate)
      const day = valentines.getDay()
      // console.log('Numero de dia = ', day)
      return day
    },
    convertNumberToWeekday (aNumber) {
      let weekday = ''
      switch (aNumber) {
        case 0:
          weekday = 'Lunes'
          break
        case 1:
          weekday = 'Martes'
          break
        case 2:
          weekday = 'Miércoles'
          break
        case 3:
          weekday = 'Jueves'
          break
        case 4:
          weekday = 'Viernes'
          break
        case 5:
          weekday = 'Sábado'
          break
        case 6:
          weekday = 'Domingo'
          break
      }
      return weekday
    },
    getCourts () {
      this.loadingDataDirectory = true
      const config = {
        method: 'get',
        url: 'https://clubtest.intrare.app/courts/by-housing-unit/' + this.getProfile.idHousingUnit,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.courts = response.data
          this.loadingDataDirectory = false
        })
        .catch(error => {
          this.loadingDataDirectory = false
          console.log(error)
        })
    },
    getCourtData (uuid) {
      console.log('PRIMERO')
      const config = {
        method: 'get',
        url: 'https://clubtest.intrare.app/courts/' + uuid,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.events = []
          // Crear Grid
          this.createGrid(response.data)
          this.idCourt = response.data.id
          this.getBooking(this.idSport)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getBooking (uuidCourt) {
      console.log('TERCERO')
      this.loadingDataDirectory = true
      const config = {
        method: 'get',
        url: 'https://clubtest.intrare.app/reservations/by-court/' + uuidCourt + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.schedule_by_sport = response.data
          this.getBookingToCalendar(response.data)
          this.loadingDataDirectory = false
        })
        .catch(error => {
          this.loadingDataDirectory = false
          console.log(error)
        })
    },
    createBooking (aDateTime) {
      this.loadingConfirmBooking = true
      this.errores = []
      let guests = []
      this.guest01 = this.guest01.trim()
      this.guest02 = this.guest02.trim()
      this.guest03 = this.guest03.trim()
      this.guest04 = this.guest04.trim()
      if (this.guest01 !== '') {
        guests.push(this.guest01)
      }
      if (this.guest02 !== '') {
        guests.push(this.guest02)
      }
      if (this.guest03 !== '') {
        guests.push(this.guest03)
      }
      if (this.guest04 !== '') {
        guests.push(this.guest04)
      }
      const config = {
        method: 'post',
        url: 'https://clubtest.intrare.app/reservations/starter-create/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          court_id: this.idCourt,
          user_id: this.idOwner,
          reservation_time: aDateTime,
          invited_people: guests
        }
      }
      axios(config)
        .then(ok => {
          this.loadingConfirmBooking = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('reservation_created_successfully'))
          this.dialog = false
          this.selectedOpen = false
          this.getBooking(this.idSport)
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loadingConfirmBooking = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              // this.errores.idOwner = error.response.data
              if (error.response.data.error === 'The user_id field is required.') {
                this.errores = ({ 'idOwner': ['Campo requerido'] })
              }
              if (error.response.data.status[0] === '0') {
                this.errorMessages = this.$t('error_msg_0')
                this.errorDialog = true
              }
              console.log(error.response.data.status[0])
            }
            if (error.response.data.non_field_errors) {
              this.errorsPhone = error.response.data.non_field_errors
              console.log(error.response.data)
            }
          }
        })
    },
    addSportSchedule () {
      this.loading = true
      this.errores = []
      const config = {
        method: 'post',
        url: 'https://clubtest.intrare.app/schedule_sport/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          idSport: this.idSport,
          day: this.weekday,
          initialTime: this.initialTime,
          finalTime: this.finalTime,
          nameInstructors: this.instructor_name
        }
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_schedule_added'))
          this.dialog = false
          this.loadSportSchedule()
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
              console.log(this.errores.phone2)
            }
            if (error.response.data.non_field_errors) {
              this.errorsPhone = error.response.data.non_field_errors
            }
          }
        })
    },
    changeStatusBooking (id, status) {
      this.loadingConfirmBooking = true
      this.errores = []

      const config = {
        method: 'patch',
        url: 'https://clubtest.intrare.app/reservations/' + id + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          status: status
        }
      }
      axios(config)
        .then(ok => {
          this.loadingConfirmBooking = false
          this.selectedOpen = false
          this.getBooking(this.idSport)
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('reservation_confirmed_successfully'))
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loadingConfirmBooking = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
            }
            if (error.response.data.non_field_errors) {
              this.errorsPhone = error.response.data.non_field_errors
            }
          }
        })
    },
    acceptOrRejectCancellation (id, status) {
      this.loadingConfirmBooking = true
      this.errores = []

      const config = {
        method: 'post',
        url: 'https://clubtest.intrare.app/reservations/' + id + '/handle_cancellation_request/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          action: status
        }
      }
      axios(config)
        .then(ok => {
          this.loadingConfirmBooking = false
          this.selectedOpen = false
          this.getBooking(this.idSport)
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('reservation_confirmed_successfully'))
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loadingConfirmBooking = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
            }
            if (error.response.data.non_field_errors) {
              this.errorsPhone = error.response.data.non_field_errors
            }
          }
        })
    },
    updateSportSchedue (id) {
      this.loading = true
      this.errores = []

      const config = {
        method: 'patch',
        url: 'https://clubtest.intrare.app/schedule_sport/' + id,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          idSport: this.idSport,
          day: this.weekday,
          initialTime: this.initialTime,
          finalTime: this.finalTime,
          nameInstructors: this.instructor_name
        }
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.loadSportSchedule()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_schedule_updated'))
          this.dialog = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
            }
            if (error.response.data.non_field_errors) {
              this.errorsPhone = error.response.data.non_field_errors
            }
          }
        })
    },
    deleteSportSchedule () {
      const config = {
        method: 'delete',
        url: ' https://clubtest.intrare.app/schedule_sport/' + this.idDirectoryDelete,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config).then(ok => {
        console.log('Registro con ID = ', this.idDirectoryDelete + ' eliminado Correctamente.')
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', this.$t('msg_schedule_deleted'))
        this.loadSportSchedule()
        setTimeout(this.clear, 3000)
        this.deleteDialog = false
      })
        .catch(error => {
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    getCutingLogo () {
      console.log('Datos de la imagen = ', this.imageFrontURL.size)
      const canvas = this.$refs.clipperImageLogo.clip() // call component's clip method
      this.resultLogoURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      console.log(this.resultLogoURL)
      this.dialogImageLogo = false
      this.dialog = true
    },
    cleanFields () {
      this.initialTime = ''
      this.finalTime = ''
      this.weekday = ''
      this.instructor_name = ''
    },
    fillFields (item) {
      this.initialTime = item.initialTime
      this.finalTime = item.finalTime
      this.weekday = item.day
      this.initialTimeAux = item.initialTime
      this.finalTimeAux = item.finalTime
      this.instructor_name = item.nameInstructors
    },
    clear: function () {
      this.errores = []
      this.errorsPhone = []
      this.$store.commit('snackbar_change_color', 'success')
      // this.$validator.reset()
      this.$store.commit('snackbar_activate_false')
    },
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    }
  }
}
</script>

<style scoped>
.edge {
  border-radius: 8px;
  border-color: #2a2738 #2a2738 #2a2738 #2a2738;
  border-width: 3px 3px 3px 3px;
  text-align: center;
  border-style: solid solid solid solid;
}
</style>
